import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useVideoGallery from "../hooks/useVideoGallery";
import useMasonryLayout from "../hooks/useMasonryLayout";
import useVideoHover from "../hooks/useVideoHover";
import GalleryItem from "../components/GalleryItem";
import VideoModal from "../components/VideoModal";
import { ChevronLeft } from "lucide-react";
import "../styles/VideoGalleryPage.css";

export default function VideoGalleryPage() {
  const navigate = useNavigate();
  const { videos, status } = useVideoGallery();
  const columns = useMasonryLayout(videos);
  const { videoRefs, play, stop } = useVideoHover();

  const [selectedIndex, setSelectedIndex] = useState(null);
  const selectedVideo =
    selectedIndex !== null ? videos[selectedIndex] : null;

  if (status === "loading") {
    return (
      <div className="gallery-full-loader">
        <div className="loader-ring" />
      </div>
    );
  }

  return (
    <>
      {/* ✅ FIXED Back Button */}
      <button
        className="back-btn_glr"
        onClick={() =>
          navigate("/", {
            state: { scrollTo: "our-obsessions" },
          })
        }
      >
        <ChevronLeft />
      </button>

      <div className="gallery-wrapper">
        {columns.map((col, colIndex) => (
          <div key={colIndex} className="gallery-column">
            {col.map((v) => (
              <GalleryItem
                key={v.id}
                video={v}
                index={v.index}
                onEnter={play}
                onLeave={stop}
                onClick={setSelectedIndex}
                videoRef={(el) => (videoRefs.current[v.index] = el)}
              />
            ))}
          </div>
        ))}
      </div>

      {selectedVideo && (
        <VideoModal
          video={selectedVideo}
          index={selectedIndex}
          total={videos.length}
          onClose={() => setSelectedIndex(null)}
          onNext={() => setSelectedIndex((i) => i + 1)}
          onPrev={() => setSelectedIndex((i) => i - 1)}
        />
      )}
    </>
  );
}